import React, { useEffect } from 'react';

import Card from '~/components/Card';
import { Button, Form } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSwapEffectApi, deleteSwapEffectApi, toggleSwapEffectPublishedStateApi } from './swapEffectSlice.js';
import EditDeleteBtn from '~/components/EditDeleteBtn';
import Datatable from '~/components/Datatable';

function SwapEffect() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { rows } = useSelector((state) => state.itemSaga.swapEffect);

    const columns = React.useMemo(
        () => [
            {
                name: '#',
                selector: (row) => row.id,
                width: '3rem',
            },
            {
                name: 'description',
                selector: (row) => row.description,
                sortable: true,
            },
            {
                name: 'Number action card to swap',
                selector: (row) => row.action_quantity,
                sortable: true,
            },
            {
                name: 'Action Card',
                selector: (row) => row.action_id,
                sortable: true,
            },
            {
                name: 'Number upgrade card to receive',
                selector: (row) => row.upgrade_quantity,
                sortable: true,
            },
            {
                name: 'Upgrade Card',
                selector: (row) => row.upgrade_id,
                sortable: true,
            },
            {
                name: 'Edit/Remove',
                cell: (row) => (
                    <EditDeleteBtn
                        hasDelete={false}
                        row={row}
                        thunkFunc={deleteSwapEffectApi}
                    />
                ),
            },
        ],
        [],
    );

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchSwapEffectApi(navigate));
    }, []);

    return (
        <Card>
            <div className={'d-flex flex-row-reverse'}>
                <Link to={'create'}>
                    <Button className={'bg-info border border-info'}>Create</Button>
                </Link>
            </div>
            <div className="col-sm-12">
                <Datatable
                    columns={columns}
                    rows={rows}
                />
            </div>
        </Card>
    );
}

export default SwapEffect;
//ref: https://codesandbox.io/s/react-bootstrap-formik-pb831?from-embed=&file=/src/form-section-1.js:436-570
/**Notes */
//(1) even though this is reset buttton, don't use type="reset" here as it will cause nested form fields (like FormikArray) unable to be reset to its inital values (I debugged and figured it out).
